import React, { useState, useEffect } from 'react';
import {
  FaIdCard, FaDownload, FaPrint, FaRedo, FaSearch, FaCalendar, FaClock, FaEye,
  FaUser, FaMapMarkerAlt, FaEnvelope, FaPhone, FaTint, FaBuilding, FaGlobe,
  FaLink, FaCheckCircle, FaTimes, FaSpinner, FaArrowLeft, FaArrowRight,
  FaFilter, FaSync, FaEdit, FaTrash, FaExclamationTriangle, FaTimesCircle
} from 'react-icons/fa';
import axios from 'axios';
import { toast } from 'react-toastify';

const RejectedIdCard = () => {
  const [rejectedCards, setRejectedCards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // Search and pagination states
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  useEffect(() => {
    fetchRejectedCards();
  }, []);

  // Filter and pagination logic
  const getFilteredCards = () => {
    let filtered = rejectedCards.filter(card => {
      const matchesSearch = !search ||
        (card.name && card.name.toLowerCase().includes(search.toLowerCase())) ||
        (card.email && card.email.toLowerCase().includes(search.toLowerCase())) ||
        (card.mobileNo && card.mobileNo.toString().includes(search)) ||
        (card.reporter?.iinsafId && card.reporter.iinsafId.toLowerCase().includes(search.toLowerCase()));

      return matchesSearch;
    });

    return filtered;
  };

  const filteredCards = getFilteredCards();
  const totalPages = Math.ceil(filteredCards.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedCards = filteredCards.slice(startIndex, endIndex);

  const fetchRejectedCards = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/get/rejected/icards`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      console.log("this is response data of rejected:", response.data);


      const cardsData = response.data.reportersIdCard || response.data.data || response.data || [];

      if (Array.isArray(cardsData)) {
        setRejectedCards(cardsData);
      } else {
        console.warn("API response is not an array:", cardsData);
        setRejectedCards([]);
      }
    } catch (err) {
      console.error("Error fetching rejected ID cards:", err);
      setError(err.response?.data?.message || err.message || "Failed to fetch rejected ID cards");
      setRejectedCards([]);
    } finally {
      setLoading(false);
    }
  };

  // Function to handle reapproval of rejected ID card
  const handleReapproveIdCard = async () => {

    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/get/rejected/icards`, {}, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });


      console.log("Reapproval response:", response.data);
      if (response.status === 200) {
        toast.success("ID card reapproved successfully!");
      } else {
        toast.error("Failed to reapprove ID card.");
      }
      // Refresh the list of rejected cards after reapproval


      console.log("Reapproval response:", response.data);
      if (response.status === 200) {
        alert("ID card reapproved successfully!");
      } else {
        alert("Failed to reapprove ID card.");
      }
      // Refresh the list of rejected cards after reapproval
      fetchRejectedCards();
    } catch (error) {
      console.error("Error reapproving ID card:", error);
    }
  };

  // Loading state
  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-red-50 to-rose-100 py-6">
        <div className="w-full px-6">
          <div className="flex justify-center items-center h-64">
            <div className="flex flex-col items-center">
              <div className="relative mb-4 w-16 h-16 grid place-items-center">
                <span className="absolute inset-0 rounded-full border-4 border-transparent border-r-red-600 animate-spin" style={{ borderWidth: "4px" }} />
                <span className="absolute inset-0 m-1 rounded-full border-4 border-transparent border-r-red-500 animate-spin-slow" style={{ borderWidth: "4px", animationDuration: "2s" }} />
                <span className="absolute inset-0 m-2 rounded-full border-4 border-transparent border-r-red-400 animate-spin-slower" style={{ borderWidth: "4px", animationDuration: "3s" }} />
              </div>
              <span className="text-lg font-semibold text-red-700 tracking-wide">Loading Rejected ID Cards...</span>
              <span className="text-sm text-gray-500 mt-2">Please wait while we fetch the data.</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Error state
  if (error) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-red-50 to-rose-100 py-6">
        <div className="w-full px-6">
          <div className="flex justify-center items-center h-64">
            <div className="bg-white rounded-2xl shadow-lg border border-red-200 p-8 text-center max-w-md">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <FaExclamationTriangle className="w-8 h-8 text-red-600" />
              </div>
              <h3 className="text-xl font-semibold text-red-700 mb-2">Error Loading Data</h3>
              <p className="text-gray-600 mb-4">{error}</p>
              <button
                onClick={fetchRejectedCards}
                className="px-6 py-3 bg-red-600 text-white rounded-xl hover:bg-red-700 transition-colors font-medium flex items-center gap-2 mx-auto"
              >
                <FaSync className="w-4 h-4" />
                Try Again
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 to-rose-100 py-6">
      <div className="w-full px-6">
        {/* Header Section */}
        <div className="bg-white rounded-2xl shadow-lg border border-gray-200 mb-6 overflow-hidden">
          <div className="bg-gradient-to-r from-red-600 via-rose-600 to-pink-600 px-6 py-8">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-white bg-opacity-20 rounded-xl flex items-center justify-center">
                  <FaIdCard className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h1 className="text-3xl font-bold text-white">Rejected ID Cards</h1>
                  <p className="text-red-100 mt-1">Total: {rejectedCards.length} rejected applications</p>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <button
                  onClick={fetchRejectedCards}
                  className="px-4 py-2 bg-white bg-opacity-20 text-white rounded-xl hover:bg-opacity-30 transition-all duration-200 flex items-center gap-2"
                >
                  <FaSync className="w-4 h-4" />
                  Refresh
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Search and Filter Section */}
        <div className="bg-white rounded-2xl shadow-lg border border-gray-200 mb-6 p-6">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
            <div className="flex-1">
              <div className="relative">
                <FaSearch className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
                <input
                  type="text"
                  className="w-full pl-12 pr-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-red-500 focus:border-transparent bg-gray-50"
                  placeholder="Search by name, email, mobile, or IINSAF ID..."
                  value={search}
                  onChange={e => setSearch(e.target.value)}
                />
              </div>
            </div>
            <div className="flex gap-3">
              <button
                onClick={() => window.location.reload()}
                className="px-4 py-3 bg-red-600 text-white rounded-xl hover:bg-red-700 transition-colors flex items-center gap-2"
              >
                <FaSync className="w-4 h-4" />
                Refresh
              </button>
            </div>
          </div>
        </div>

        {/* Table Section */}
        <div className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="min-w-full">
              <thead className="bg-gradient-to-r from-red-600 via-rose-600 to-pink-600">
                <tr>
                  <th className="px-6 py-4 text-left text-xs font-semibold text-white uppercase tracking-wider">
                    <div className="flex items-center gap-2">
                      <FaUser className="w-4 h-4" />
                      User
                    </div>
                  </th>
                  <th className="px-6 py-4 text-left text-xs font-semibold text-white uppercase tracking-wider">
                    <div className="flex items-center gap-2">
                      <FaIdCard className="w-4 h-4" />
                      IINSAF ID
                    </div>
                  </th>
                  <th className="px-6 py-4 text-left text-xs font-semibold text-white uppercase tracking-wider">
                    <div className="flex items-center gap-2">
                      <FaEnvelope className="w-4 h-4" />
                      Contact
                    </div>
                  </th>
                  <th className="px-6 py-4 text-left text-xs font-semibold text-white uppercase tracking-wider">
                    <div className="flex items-center gap-2">
                      <FaMapMarkerAlt className="w-4 h-4" />
                      Location
                    </div>
                  </th>
                  <th className="px-6 py-4 text-left text-xs font-semibold text-white uppercase tracking-wider">
                    <div className="flex items-center gap-2">
                      <FaCalendar className="w-4 h-4" />
                      Rejected Date
                    </div>
                  </th>
                  <th className="px-6 py-4 text-left text-xs font-semibold text-white uppercase tracking-wider">
                    <div className="flex items-center gap-2">
                      <FaTimes className="w-4 h-4" />
                      Rejection Reason
                    </div>
                  </th>
                  <th className="px-6 py-4 text-left text-xs font-semibold text-white uppercase tracking-wider">
                    <div className="flex items-center gap-2">
                      <FaGlobe className="w-4 h-4" />
                      Channel Links
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {paginatedCards.length > 0 ? (
                  paginatedCards.map((card, index) => (
                    <tr key={card._id || card.id || index} className="hover:bg-gray-50 transition-colors">
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="flex items-center">
                          <div className="flex-shrink-0 h-12 w-12">
                            {card.image ? (
                              <img
                                className="h-12 w-12 rounded-full object-cover border-2 border-gray-200"
                                src={card.image}
                                alt={card.name || 'Reporter'}
                              />
                            ) : (
                              <div className="h-12 w-12 rounded-full bg-red-100 flex items-center justify-center">
                                <FaIdCard className="w-6 h-6 text-red-600" />
                              </div>
                            )}
                          </div>
                          <div className="ml-4">
                            <div className="text-sm font-medium text-gray-900">{card.name || 'Unknown'}</div>
                            <div className="text-sm text-gray-500">{card.designation || 'N/A'}</div>
                            <div className="text-xs text-gray-400 flex items-center gap-1">
                              <FaTint className="w-3 h-3" />
                              {card.bloodGroup || 'N/A'}
                            </div>
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
                          {card.reporter?.iinsafId || 'N/A'}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-gray-900 flex items-center gap-1">
                          <FaEnvelope className="w-3 h-3 text-gray-400" />
                          {card.email || 'N/A'}
                        </div>
                        <div className="text-sm text-gray-500 flex items-center gap-1">
                          <FaPhone className="w-3 h-3 text-gray-400" />
                          {card.mobileNo || 'N/A'}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-gray-900 flex items-center gap-1">
                          <FaBuilding className="w-3 h-3 text-gray-400" />
                          {card.city || 'N/A'}
                        </div>
                        <div className="text-sm text-gray-500 flex items-center gap-1">
                          <FaMapMarkerAlt className="w-3 h-3 text-gray-400" />
                          {card.state || 'N/A'}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-gray-900">
                          {card.updatedAt ? new Date(card.updatedAt).toLocaleDateString() : 'N/A'}
                        </div>
                        <div className="text-xs text-gray-500 flex items-center gap-1">
                          <FaClock className="w-3 h-3" />
                          {card.updatedAt ? new Date(card.updatedAt).toLocaleTimeString() : 'N/A'}
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        {card.rejectNote ? (
                          <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800 max-w-xs">
                            {card.rejectNote}
                          </span>
                        ) : (
                          <span className="text-gray-400 text-sm">N/A</span>
                        )}
                      </td>
                      <td className="px-6 py-4">
                        {card.channelLinks && card.channelLinks.length > 0 ? (
                          <div className="flex flex-col space-y-1">
                            {card.channelLinks.slice(0, 2).map((link, linkIndex) => (
                              <a
                                key={linkIndex}
                                href={link.link || link.url || link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-600 hover:text-blue-800 text-xs flex items-center gap-1 truncate max-w-xs"
                              >
                                <FaLink className="w-3 h-3 flex-shrink-0" />
                                {link.platform || link.name || link.link || link.url || link}
                              </a>
                            ))}
                            {card.channelLinks.length > 2 && (
                              <span className="text-xs text-gray-500">+{card.channelLinks.length - 2} more</span>
                            )}
                          </div>
                        ) : (
                          <span className="text-gray-400 text-sm">N/A</span>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={7} className="px-6 py-16 text-center">
                      <div className="flex flex-col items-center">
                        <div className="w-24 h-24 bg-gradient-to-br from-gray-200 to-gray-300 rounded-full flex items-center justify-center mx-auto mb-4">
                          <FaIdCard className="w-12 h-12 text-gray-400" />
                        </div>
                        <h3 className="text-xl font-semibold text-gray-600 mb-2">No Rejected ID Cards Found</h3>
                        <p className="text-gray-500 mb-4">
                          {search
                            ? "No cards match your current search."
                            : "No rejected ID cards available at the moment."
                          }
                        </p>
                        {search && (
                          <button
                            onClick={() => {
                              setSearch("");
                            }}
                            className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
                          >
                            Clear Search
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="bg-gray-50 px-6 py-4 border-t border-gray-200">
              <div className="flex items-center justify-between">
                <div className="text-sm text-gray-700">
                  Showing {startIndex + 1} to {Math.min(endIndex, filteredCards.length)} of {filteredCards.length} results
                </div>
                <div className="flex items-center space-x-2">
                  <button
                    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                    disabled={currentPage === 1}
                    className="px-3 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-1"
                  >
                    <FaArrowLeft className="w-3 h-3" />
                    Previous
                  </button>

                  {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                    <button
                      key={page}
                      onClick={() => setCurrentPage(page)}
                      className={`px-3 py-2 text-sm font-medium rounded-lg ${currentPage === page
                        ? 'bg-red-600 text-white'
                        : 'text-gray-700 bg-white border border-gray-300 hover:bg-gray-50'
                        }`}
                    >
                      {page}
                    </button>
                  ))}

                  <button
                    onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                    disabled={currentPage === totalPages}
                    className="px-3 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-1"
                  >
                    Next
                    <FaArrowRight className="w-3 h-3" />
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default RejectedIdCard;